export const getGaData = () => window.gaData;
